/**
 * Privacy Policy Header
 * Renders the dark header section of the Privacy Policy page.
 */

export const PrivacyPolicyHeader = () => (
  <header className="bg-[#4E4A52]">
    <main className="container pb-16 pt-32">
      <p className="font-termina text-white font-black pb-6">THE BQUEST LLC</p>
      <h1 className="font-recoleta text-white font-black pb-6">
        Privacy Policy
      </h1>
      <p className="font-recoleta text-white font-black text-lg pb-6">
        Please read the following Privacy Policy carefully. If you do not agree
        with this Privacy Policy, you may not use the bQuest applications,
        website, platform, or other software or technology products.
      </p>
      <h3 className="font-recoleta text-white">
        Last updated October 27, 2023
      </h3>
    </main>
  </header>
);
